import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth-service';

@Injectable({
  providedIn: 'root'
})


export class AuthGuardGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router
  ) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (token && token !== 'null' && token !== 'undefined' && token !== '') {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', token);
      }
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
